<template>
  <div>
    <div class="centered aligned row statisticRow">
      <div class="ui mini statistic">
        <div class="value">
          <i class="icon" :class="icon"></i>
          {{ (currentItems && currentItems.length) || 0 }}
        </div>
        <div class="label">
          {{ $tc(type, (currentItems && currentItems.length) || 0) | capitalize }}
        </div>
      </div>
    </div>

    <typeahead
      class="typeaheadInput"
      :items="items"
      :placeholder-text="$tc(type, 1)"
      :empty-text="$t('NO_ITEMS_MATCH', { things: $tc(type, 2) })"
      :select-handler="add"
      ref="typeaheadInput"
      :disabled="isDisabled"
    />

    <div class="ui link list">
      <div class="item" v-for="i in currentItems" :key="i.id">
        <div class="right floated content">
          <i
            class="exclamation triangle yellow icon"
            :title="$t(i.warning)"
            v-visible="i.isWarning"
          />
          <i
            class="delete removeItemIcon icon"
            v-if="!isDisabled"
            @click.stop.prevent="remove(i)"
          ></i>
        </div>
        <div class="content">
          <color-label :color="i.color" size="tiny" v-if="i.color" />
          <router-link
            class="item singleItem"
            :event="isDisabled ? '' : 'click'"
            :to="to(i)"
            :key="i.id"
          >
            <div class="ellipsis" :style="styleObject(i)">{{ i.name }}</div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@charset "utf-8";

.statisticRow {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.typeaheadInput {
  padding-top: 10px;
}

.removeItemIcon:hover {
  color: #4d4d4d;
}

.ui.grid > .column:not(.row) {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.singleItem {
  height: 1.5em;
  padding: 0;
  margin: 0;
}

.content {
  display: flex;
  justify-content: start;
  align-items: top;

  .tiny.empty.label {
    margin: 2px 10px 2px 2px;
  }
}
</style>

// @flow
<script>
import Typeahead from '../Typeahead/Typeahead'
import _ from 'lodash'
import ColorLabel from '../ColorLabel/ColorLabel'

export default {
  name: 'add-delete-list',
  components: { Typeahead, ColorLabel },
  props: {
    icon: {
      type: String,
      default: () => ''
    },
    allItems: {
      type: Array,
      default: () => []
    },
    currentItems: {
      type: Array,
      default: () => []
    },
    to: null,
    type: {
      type: String,
      default: () => ''
    },
    onRemove: {
      type: Function,
      default: () => ''
    },
    onAdd: {
      type: Function,
      default: () => ''
    },
    isDisabled: {
      type: Boolean,
      default: () => false
    },
    diff: {
      Object,
      default: () => {
        added: []
        removed: []
      }
    }
  },

  computed: {
    items() {
      return _.filter(this.allItems, a => !_.includes(this.currentItems.map(i => i.id), a.id))
    }
  },
  methods: {
    add(i) {
      this.$refs.typeaheadInput.clearModel()
      this.onAdd(i)
      this.$emit('add', i)
    },
    remove(i) {
      this.onRemove(i)
      this.$emit('remove', i)
    },
    styleObject(el) {
      if (this.isAdded(el)) {
        return {
          color: 'green'
        }
      } else if (this.isRemoved(el)) {
        return {
          color: 'red'
        }
      }
    },
    isAdded(el) {
      return this.diff && _.includes(this.diff.added, el.id)
    },
    isRemoved(el) {
      return this.diff && _.includes(this.diff.removed, el.id)
    }
  }
}
//
</script>
